import BaseModel from "../BaseModel";
import Customer from "./Customer";
import NameType from "./NameType";
import InvoiceItem from "./InvoiceItem";

export default class Invoice extends BaseModel{
    static entity = 'invoices';
    static primaryKey = "uuid";
    static fields(){
        return {
            uuid: this.attr(null),
            customer_id: this.attr(null),
            invoice_id: this.attr(null),
            invoice_date: this.attr(null),
            due_date: this.attr(null),
            exported: this.attr(null),
            items: this.hasMany(InvoiceItem, "invoice_uuid")
        }
    }
    static ignoredLogFields(){
        return ['created_at', 'updated_at', 'items']
    }
    static route(){
        return '/invoices'
    }
}
